import React from "react";
import PropTypes from "prop-types";
import { Drawer, Tabs } from "antd";
import QuestionDetailView from "./QuestionDetailView";
import QuestionHistoryTab from "./QuestionHistoryTab";
import { formatDateTime, getAttemptCount, getAudit, getQuestionId } from "./questionHelpers";

/** One place to read a question: everything it contains, and everything that was done to it. */
const QuestionDetailDrawer = ({
    open,
    question,
    syllabusNameById,
    historyEnabled,
    canRestore,
    activeTab,
    onTabChange,
    onClose,
    onRestored,
}) => {
    const audit = getAudit(question || {});
    const questionId = getQuestionId(question);
    const attemptCount = getAttemptCount(question);

    const items = [
        {
            key: "details",
            label: "Details",
            children: (
                <>
                    <QuestionDetailView
                        question={question}
                        syllabusNameById={syllabusNameById}
                    />
                    <div className="qdrawer__audit">
                        <div>
                            <span>Created</span>
                            <b>
                                {formatDateTime(audit.createdOn)}
                                {audit.createdByName ? ` by ${audit.createdByName}` : ""}
                            </b>
                        </div>
                        <div>
                            <span>Last updated</span>
                            <b>
                                {audit.lastUpdatedOn
                                    ? `${formatDateTime(audit.lastUpdatedOn)}${audit.lastUpdatedByName ? ` by ${audit.lastUpdatedByName}` : ""
                                    }`
                                    : "Never edited"}
                            </b>
                        </div>
                        <div>
                            <span>Times updated</span>
                            <b>{audit.updateCount ?? 0}</b>
                        </div>
                        {attemptCount > 0 && (
                            <div>
                                <span>Answered by students</span>
                                <b>{attemptCount}</b>
                            </div>
                        )}
                    </div>
                </>
            ),
        },
    ];

    if (historyEnabled) {
        items.push({
            key: "history",
            label: `History${audit.updateCount ? ` (${audit.updateCount})` : ""}`,
            children: open ? (
                <QuestionHistoryTab
                    questionId={questionId}
                    syllabusNameById={syllabusNameById}
                    canRestore={canRestore}
                    attemptCount={attemptCount}
                    onRestored={onRestored}
                />
            ) : null,
        });
    }

    return (
        <Drawer
            open={open}
            onClose={onClose}
            width={820}
            title={question?.moduleName ? `Question · ${question.moduleName}` : "Question"}
            className="qdrawer"
            destroyOnHidden
        >
            <Tabs activeKey={activeTab} onChange={onTabChange} items={items} />
        </Drawer>
    );
};

QuestionDetailDrawer.propTypes = {
    open: PropTypes.bool,
    question: PropTypes.object,
    syllabusNameById: PropTypes.object,
    historyEnabled: PropTypes.bool,
    canRestore: PropTypes.bool,
    activeTab: PropTypes.string,
    onTabChange: PropTypes.func,
    onClose: PropTypes.func,
    onRestored: PropTypes.func,
};

export default QuestionDetailDrawer;
